import _ from 'lodash';

export const SortField = {
  availibility:'Availability (Default)',
  name: 'Train Name',
  departure: 'Departure',
  duration: 'Travel Time',
  arrival: 'Arrival',
};

export const DEFAULT_SORT = SortField.availibility;
const SortFields = _.values(SortField);
export default SortFields;
